import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["cell"]

  connect() {
    HSDropdown.autoInit();
  }

  toggle(event) {
    const columnName = event.target.value;
    const isVisible = event.target.checked;

    const columnCells = this.cellTargets.filter((cell) => cell.dataset.columnName == columnName);

    if (isVisible)
      columnCells.forEach(cell => cell.classList.remove('hidden'));
    else
      columnCells.forEach(cell => cell.classList.add('hidden'));
  }
}
